<template>
  <div
    class="text-gray-dark text-tiny font-sans overflow-x-scroll -mr-12 md:mr-0 my-14"
  >
    <div class="min-w-200 pr-12 md:pr-0">
      <table
        class="w-full border-b border-gray-lighter table-fixed break-words"
        cellspacing="0"
        role="grid"
      >
        <thead class="bg-white-dark border-y border-gray-lighter">
          <tr role="row">
            <th
              class="py-2.4 px-6 text-sm md:text-tiny md:px-8 text-left hover:bg-gray-lightest w-48 md:56"
            >
              <strong>Società Terze</strong>
            </th>
            <th
              class="py-2.4 px-6 text-sm md:text-tiny md:px-8 text-left hover:bg-gray-lightest"
            >
              <strong
                >Link alle pagine Web <br aria-hidden="true" />
                contenenti le informative <br aria-hidden="true" />
                e le richieste di consenso <br aria-hidden="true" />
                delle Società</strong
              >
            </th>
            <th
              class="py-2.4 px-6 text-sm md:text-tiny md:px-8 text-left hover:bg-gray-lightest"
            >
              <strong>Scopo del Cookie</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, i) in items" :key="i" role="row" class="odd">
            <td
              class="pt-2.8 pb-6 px-4 w-48 md:56"
              :class="{ 'border-t border-gray-lighter': i === 0 }"
              valign="top"
            >
              <p>
                <strong>{{ item.title }}</strong>
              </p>
            </td>
            <td
              class="pt-2.8 pb-6 px-4"
              :class="{ 'border-t border-gray-lighter': i === 0 }"
              valign="top"
            >
              <p
                v-for="(link, index) in item.links"
                :key="index"
                :class="{ 'mb-5': index + 1 < item.links.length }"
              >
                <a
                  :href="link"
                  target="_blank"
                  class="text-blue"
                  v-text="link"
                ></a>
              </p>
            </td>
            <td
              class="pt-2.8 pb-6 px-4"
              :class="{ 'border-t border-gray-lighter': i === 0 }"
              valign="top"
            >
              <p>{{ item.description }}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
